import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import type { MantineSize } from '@mantine/core'
import { getPortDef, sizes, margins, paddings } from '@shared/port-v1.0.0'
import Comp from '../component'

export type Props = BaseReactProps & {
	gap: MantineSize
	rowGap: MantineSize
	columnGap: MantineSize
	align: 'flex-start' | 'center' | 'flex-end'
	justify: 'flex-start' | 'center' | 'flex-end' | 'space-between'
	direction: 'row' | 'column' | 'row-reverse' | 'column-reverse'
	wrap: 'wrap' | 'nowrap' | 'wrap-reverse'
}

export default {
	hashTag: '#pre-release',
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({
				name: 'gap',
				displayName: 'Gap',
				group: 'Layout',
				type: sizes,
				default: 'md',
			}),
			getPortDef({
				name: 'rowGap',
				displayName: 'Row gap',
				group: 'Layout',
				type: sizes,
				default: 'md',
			}),
			getPortDef({
				name: 'columnGap',
				displayName: 'Column gap',
				group: 'Layout',
				type: sizes,
				default: 'md',
			}),
			getPortDef({
				name: 'align',
				displayName:'Align',
				group: 'Layout',
				type: [
					{ label: 'Flex start', value: 'flex-start' },
					{ label: 'Center', value: 'center' },
					{ label: 'Flex end', value: 'flex-end' }
				],
				default: 'flex-start',
			}),
			getPortDef({
				name: 'justify',
				displayName: 'Justify',
				group: 'Layout',
				type: [
					{ label: 'Flex start', value: 'flex-start' },
					{ label: 'Center', value: 'center' },
					{ label: 'Flex end', value: 'flex-end' },
					{ label: 'Space between', value: 'space-between' },
				],
				default: 'flex-start',
			}),
			getPortDef({
				name: 'direction',
				displayName: 'Direction',
				group: 'Layout',
				type: [
					{ label: 'Row', value: 'row' },
					{ label: 'Column', value: 'column' },
					{ label: 'Row reverse', value: 'row-reverse' },
					{ label: 'Column reverse', value: 'column-reverse' },
				],
				default: 'row',
			}),
			getPortDef({
				name: 'wrap',
				displayName: 'Wrap',
				group: 'Layout',
				type: [
					{ label: 'Wrap', value: 'wrap' },
					{ label: 'No wrap', value: 'nowrap' },
					{ label: 'Wrap reverse', value: 'wrap-reverse' }
				],
				default: 'wrap',
			}),

			getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'h', displayName: 'Height', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'opacity', displayName: 'Opacity', group: 'Styles', type: 'number', default: 1 }),
			...margins,
			...paddings
		],
	},
} satisfies ReactNodeDef